export const LOGO_DARK =
  'https://fynodev.s3.ap-south-1.amazonaws.com/brand/fynologo2025.svg'

export const LOGO_LIGHT =
  'https://fynodev.s3.ap-south-1.amazonaws.com/brand/fynobrand2025.svg'

export const OFFLINE_MESSAGE = 'You are offline now, please check your internet'
